import React, { Component } from 'react'

class linkForEdit extends Component {
    constructor(props) {
        super(props)
        this.state = {
            userId: ""
        }
    }


    componentDidMount() {
        this.setState({
            //userId:localStorage.getItem("userId"),
            // userId:localStorage.getItem("phoneId")
        })

        let webid = new URLSearchParams(this.props.location.search);
        let userId = webid.get("userId");
        let admin = webid.get("admin");

        // console.log(userId)
        localStorage.setItem("userId", userId)
        localStorage.setItem("admin", admin)
        this.props.history.push(`/AdminProfile/FullbiodataAdmin`);
        // console.log("paymentid",webidnew+ "userid",localStorage.getItem("userId"),)

    }
    render() {
        return (
            <div>

            </div>
        )
    }
}

export default linkForEdit
